import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { HeatingType } from '../../../../@store';

@Component({
  selector: 'app-heating-type-form',
  templateUrl: './heating-type-form.component.html',
  styleUrls: ['./heating-type-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeatingTypeFormComponent {
  heatingTypes: {
    type: HeatingType;
    title: string;
    image: string;
    caution: string;
    description: string;
    tip: string;
  }[] = [
    {
      type: HeatingType.FloorHeating,
      title: '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.HEATING_TYPES.FLOOR_HEATING.TITLE',
      image: 'assets/img/gateway-commissioning/heating-type-panel-heating.svg',
      caution: '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.HEATING_TYPES.CAUTION',
      description:
        '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.HEATING_TYPES.FLOOR_HEATING.DESCRIPTION',
      tip: '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.HEATING_TYPES.FLOOR_HEATING.TIP',
    },
    {
      type: HeatingType.Radiators,
      title: '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.HEATING_TYPES.RADIATORS.TITLE',
      image: 'assets/img/gateway-commissioning/heating-type-radiator.svg',
      caution: '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.HEATING_TYPES.CAUTION',
      description:
        '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.HEATING_TYPES.RADIATORS.DESCRIPTION',
      tip: null,
    },
    {
      type: HeatingType.Both,
      title: '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.HEATING_TYPES.BOTH.TITLE',
      image: 'assets/img/gateway-commissioning/heating-type-both.svg',
      caution: '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.HEATING_TYPES.CAUTION',
      description: '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.HEATING_TYPES.BOTH.DESCRIPTION',
      tip: null,
    },
  ];

  @Input() selectedHeatingType: HeatingType;
  @Output() heatingTypeChange: EventEmitter<HeatingType> = new EventEmitter<HeatingType>();

  onSelectHeatingType(type: HeatingType): void {
    this.selectedHeatingType = type;
    this.heatingTypeChange.emit(type);
  }
}
